import { useForm, Controller } from "react-hook-form";
import { Pattern } from "../../packages/services";
import { CountrySelector, FormContainer, TextInput } from "../shared";
import useGlobalMutation from "../../hooks/useGlobalMutation";
import { CREATE_TIER, GET_NEXT_ORDER } from "./query";
import { clearCache } from "../../utils";
import { useEffect, useState } from "react";
import { gql, useQuery } from "@apollo/client";

const CreateTier = () => {
    const [orderFetched, setOrderFetched] = useState(false);
    const {
        control,
        register,
        handleSubmit,
        formState: { errors },
        reset,
        setValue,
        watch,
    } = useForm({
        mode: "onChange",
    });

    const country = watch("country");
    const {
        data: nextOrderData,
        loading: nextOrderLoading,
        refetch,
    } = useQuery(gql(GET_NEXT_ORDER), {
        variables: {
            country,
        },
    });

    useEffect(() => {
        if (country) {
            refetch({
                country,
            });
        }
    }, [country]);

    useEffect(() => {
        if (country) {
            if (nextOrderData && nextOrderData.allAllerganProTiers.nodes.length > 0) {
                const orderNo = nextOrderData.allAllerganProTiers.nodes[0].orderNo;
                if (!orderFetched) {
                    setValue("orderNo", Number(orderNo) + 1);
                }
            } else {
                setValue("orderNo", 1);
            }
        }
    }, [nextOrderData]);

    const { submitMutation, loading } = useGlobalMutation(CREATE_TIER, (cache) => {
        clearCache(cache, "allAllerganProTiers");
    });

    const submitAction = handleSubmit(async (data) => {
        const { tierName, orderNo, country } = data;

        const variables = {
            allerganProTier: {
                tierName,
                orderNo: Number(orderNo),
                country,
            },
        };
        const dataPath = "createAllerganProTierConfiguration.allerganProTierConfiguration";
        const isResultNull = await submitMutation(variables, dataPath, "Tier created successfully");

        if (isResultNull === null) {
            reset();
            setOrderFetched(false);
        }
    });

    return (
        <FormContainer
            submitAction={submitAction}
            backUrl={`/allergan-pro/tier`}
            customClass="custom-shadow p-5"
            title="Create Form"
            loading={loading || nextOrderLoading}
        >
            <h3 className="mb-5">Create Tier</h3>

            <div className="row">
                <div className="col-md-6">
                    <Controller
                        name="country"
                        render={({ field: { onChange, value }, fieldState: { invalid }, ref }) => (
                            <CountrySelector
                                id="country"
                                country={value}
                                labelText="Country"
                                selectCountry={onChange}
                                {...register("country", {
                                    required: true,
                                })}
                                required
                                isInvalid={invalid}
                                ref={ref}
                            />
                        )}
                        control={control}
                    />
                </div>
                <div className="col-md-6">
                    <TextInput
                        id="tierName"
                        labelText="Tier Name"
                        {...register("tierName", {
                            required: true,
                            pattern: Pattern.name,
                        })}
                        isInvalid={!!errors.tierName}
                        required
                    />
                </div>
                <div className="col-md-6">
                    <TextInput
                        id="orderNo"
                        labelText="Order Number"
                        {...register("orderNo", {
                            required: true,
                            pattern: Pattern.number,
                        })}
                        isInvalid={!!errors.orderNo}
                        required
                        disabled
                    />
                </div>
            </div>
        </FormContainer>
    );
};

export default CreateTier;
